module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('meta', {
    attrs: {
      "name": "referrer",
      "content": "never"
    }
  }), _vm._v(" "), (_vm.isRouterAlive) ? _c('router-view', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.title),
      expression: "title"
    }]
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75e17242"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 338
// module chunks = 16